import { useCallback, memo } from 'react';
import type { ComponentType } from 'react';

import RouteLink from './RouteLink';

import displayName from '@shared/utils-frontend/display-name';

type Props = {
  onClick?: Function;
  [key: string]: any;
};

const withRouterLink = <P extends Props>(
  WrappedComponent: ComponentType<P>,
  href: string,
) => {
  const component = memo((props: P) => {
    const { onClick } = props;
    const handleClick = useCallback(
      (event: any) => {
        onClick?.(event);
      },
      [onClick],
    );

    return (
      <RouteLink
        href={href}
        onClick={handleClick}
        render={(clickHandler) => (
          <WrappedComponent {...props} onClick={clickHandler} />
        )}
      />
    );
  });

  component.displayName = displayName(WrappedComponent);

  return component;
};

export default withRouterLink;
